<template>
  <el-dialog
    title="岗位详情"
    :visible.sync="dialogVisible"
    :append-to-body="true"
  >
    <table v-if="unitDetailProps && unitDetailProps.type === 'announcement'">
      <tr>
        <td>岗位名称</td>
        <td>{{ unitDetailProps && unitDetailProps.name }}</td>
        <td>新增岗位类别</td>
        <td>{{ unitDetailProps && translateUnitType(unitDetailProps.jobType) }}</td>
      </tr>
      <tr>
        <td>有效期限</td>
        <td v-if="unitDetailProps && unitDetailProps.jobType === 'Fixed'">
          {{ unitDetailProps.pVaiName }}
        </td>
        <td v-else>
          {{ unitDetailProps && (unitDetailProps.startTime) | moment('YYYY-MM-DD') }}至{{ unitDetailProps &&
            (unitDetailProps.endTime) | moment('YYYY-MM-DD') }}
        </td>
        <td>岗位招聘人数</td>
        <td>{{ unitDetailProps && unitDetailProps.numberOfNeed }}</td>
      </tr>
      <tr>
        <td>岗位月薪</td>
        <td>{{ unitDetailProps && unitDetailProps.money }}元/每月</td>
        <td>当前已申请人数</td>
        <td>{{ unitDetailProps && unitDetailProps.numberOfOn }}</td>
      </tr>
      <tr>
        <td>联系电话</td>
        <td>{{ unitDetailProps && unitDetailProps.phone }}</td>
        <td>申请截止时间</td>
        <td>{{ unitDetailProps && unitDetailProps.deadTime | moment('YYYY-MM-DD') }}</td>
      </tr>
      <tr>
        <td>指导教师</td>
        <td>{{ unitDetailProps && unitDetailProps.teacher }}</td>
        <td>本单位其他岗位</td>
        <td>
          <el-button
            type="text"
            @click="view"
          >点击查看
          </el-button>
        </td>
      </tr>
      <tr>
        <td>在岗人数</td>
        <td
          colspan="3"
          class="longCol"
        >{{ unitDetailProps && unitDetailProps.numberOfWorking }}
        </td>
      </tr>
      <tr v-if="unitDetailProps && !unitDetailProps.isStudent">
        <td>
          申请限制（满足以下条件学生才可申请该岗位）
        </td>
        <td
          colspan="3"
          class="longCol"
        >
          <div
            v-for="(item, index) in unitDetailProps.jobLimitList"
            :key="index"
          >
            <span>{{ poolLevelTranslate(item.poorLevel) }}</span>
            <span v-if="item.monthMoneyCap&&item.monthMoneyCap!==''">,月工资上限: {{ item.monthMoneyCap }}</span>
            <span v-else>,无工资上限</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>工作时间说明</td>
        <td
          colspan="3"
          class="longCol"
        >
          {{ unitDetailProps && unitDetailProps.workDesc }}
        </td>
      </tr>
      <tr>
        <td>岗位职责</td>
        <td
          colspan="3"
          class="longCol"
        >
          {{ unitDetailProps && unitDetailProps.jobContent }}
        </td>
      </tr>
      <tr>
        <td>招聘要求</td>
        <td
          colspan="3"
          class="longCol"
        >
          {{ unitDetailProps && unitDetailProps.requirements }}
        </td>
      </tr>
      <tr>
        <td>提交材料</td>
        <td
          colspan="3"
          class="longCol"
        >
          <a href="#" @click="fileDownload(unitDetailProps.file)">{{ unitDetailProps.file.name }}</a>
        </td>
      </tr>
    </table>

    <table v-else>
      <tr>
        <td>岗位名称</td>
        <td>{{ unitDetailProps && unitDetailProps.name }}</td>
        <td>新增岗位类别</td>
        <td>{{ unitDetailProps && translateUnitType(unitDetailProps.jobType) }}</td>
      </tr>
      <tr>
        <td>有效期限</td>
        <td v-if="unitDetailProps && unitDetailProps.jobType === 'Fixed'">
          {{ unitDetailProps.pVaiName }}
        </td>
        <td v-else>
          {{ unitDetailProps && (unitDetailProps.startTime) | moment('YYYY-MM-DD') }}至{{ unitDetailProps &&
            (unitDetailProps.endTime) | moment('YYYY-MM-DD') }}
        </td>
        <td>岗位招聘人数</td>
        <td>{{ unitDetailProps && unitDetailProps.numberOfNeed }}</td>
      </tr>
      <tr>
        <td>岗位月薪</td>
        <td>{{ unitDetailProps && unitDetailProps.money }}元/每月</td>
        <td>指导教师</td>
        <td>{{ unitDetailProps && unitDetailProps.teacher }}</td>
      </tr>
      <tr>
        <td>联系电话</td>
        <td>{{ unitDetailProps && unitDetailProps.phone }}</td>
        <td>申请截止时间</td>
        <td>{{ unitDetailProps && unitDetailProps.deadTime | moment('YYYY-MM-DD') }}</td>
      </tr>
      <tr>
        <td>在岗人数</td>
        <td
          colspan="3"
          class="longCol"
        >{{ unitDetailProps && unitDetailProps.numberOfWorking }}
        </td>
      </tr>
      <tr v-if="unitDetailProps && !unitDetailProps.isStudent">
        <td>
          申请限制（满足以下条件学生才可申请该岗位）
        </td>
        <td
          colspan="3"
          class="longCol"
        >
          <div
            v-for="(item, index) in unitDetailProps.jobLimitList"
            :key="index"
          >
            <span>{{ poolLevelTranslate(item.poorLevel) }}</span>
            <span v-if="item.monthMoneyCap&&item.monthMoneyCap!==''">,月工资上限: {{ item.monthMoneyCap }}</span>
            <span v-else>,无工资上限</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>工作时间说明</td>
        <td
          colspan="3"
          class="longCol"
        >
          {{ unitDetailProps && unitDetailProps.workDesc }}
        </td>
      </tr>
      <tr>
        <td>岗位职责</td>
        <td
          colspan="3"
          class="longCol"
        >
          {{ unitDetailProps && unitDetailProps.jobContent }}
        </td>
      </tr>
      <tr>
        <td>招聘要求</td>
        <td
          colspan="3"
          class="longCol"
        >
          {{ unitDetailProps && unitDetailProps.requirements }}
        </td>
      </tr>
      <tr>
        <td>提交材料</td>
        <td
          colspan="3"
          class="longCol"
        >
          <a href="#" @click="fileDownload(unitDetailProps.file)">{{ unitDetailProps.file.name }}</a>
        </td>
      </tr>
    </table>

    <div
      v-if="showApply"
      style="width: 100%;text-align: center"
    >
      <el-button
        type="primary"
        style="width: 300px; margin: 20px auto 0"
        :disabled="unitDetailProps && unitDetailProps.hasApply"
        @click="appUnit"
      >申请岗位
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { translateUnitType, poolLevelTranslate } from '@/tool/utils'
import { fileDownload } from '@/api/api'

export default {
  name: 'UnitDetailDialog',
  props: {
    showApply: Boolean,
    unitDetailProps: Object,
    appUnit: {
      type: Function,
    },
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    translateUnitType,
    poolLevelTranslate,
    fileDownload(file) {
      fileDownload({ path: file.path }).then(res => {
        const blob = new Blob([res])
        const elink = document.createElement('a')
        elink.download = file.name
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.removeChild(elink)
      })
    },
    view() {
      this.dialogVisible = false
      this.$emit('unit')
    },
  },
}
</script>

<style scoped lang="less">
    @import "../styles/var";

    table {
        .table-style();

        .longCol {
            text-align: left;
            padding: 10px;
        }
    }

    table td {
        .td-style ();
    }

    @media only screen and (max-width: 40em) {
      table td {
        min-width: 1px !important;
      }
    }
</style>
